export default __webpack_public_path__ + "static/media/cartop-pm2.e76058f7.jpg";